(() => {
  const addToDom = (parent, tag, attributes = {}) => {
    const child = document.createElement(tag)
    Object.entries(attributes).forEach(([key, value]) => {
      if (key === 'class') {
        value.split(' ').forEach(x => child.classList.add(x))
      } else {
        child.setAttribute(key, value)
      }
    })
    parent.appendChild(child)
    return child
  }
  
  const getFormattedData = (array) => {
    const sections = [... new Set(array.map(x => x.section))]
  
    return sections.map(x => {
      const objData = array.filter(y => y.section === x).map(z => ({ header: z.header, text: z.text }))
      return { section: x, data: objData }
    })
  }
  
  const createAccoridonHTML = (item, index) => {
    const firstClass = index === 0 ? ' accordion--first' : ''
    return `
      <div class="product__accordion accordion${firstClass}">
        <details>
          <summary>
            <div class="summary__title">
              <h2 class="h2 accordion__title">
                ${item.header}
              </h2>
            </div>
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
            </svg>
          </summary>
          <div class="accordion__content rte">
            ${item.text}
          </div>
        </details>
      </div>
    `
  }
  
  const removeSidebarActiveClass = () => {
    const currentActive = document.querySelector('.activeLinkSidebar');
    if (currentActive !== null) currentActive.classList.remove('activeLinkSidebar');
  }

  const observerCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const menuItem = menuItems[entry.target.id]
        removeSidebarActiveClass()
        menuItem.classList.add('activeLinkSidebar')
      }
    })
  }

  const runMain = () => {
    const allData = JSON.parse(document.getElementById('textJSON').textContent)
    const formattedData = getFormattedData(allData)
    const container = document.querySelector('.text-section__container')
    const menu = addToDom(container, 'div', { class: 'text-section__menu' })
    const list = addToDom(container, 'div', { class: 'text-section__list' })

    const menuItems = {}
    const sections = []

    formattedData.forEach(obj => {
      const newMenuItem = addToDom(menu, 'a', { href: `#${obj.section}`, class: 'text-section__menu__item no-select--custom' })
      newMenuItem.innerHTML = `<span>${obj.section}</span>`
      menuItems[obj.section] = newMenuItem

      const sectionDiv = addToDom(list, 'section', { class: 'text-section__list__section-wrapper', id: obj.section })
      sectionDiv.innerHTML = `<span>${obj.section}</span>`
      sections.push(sectionDiv)

      obj.data.forEach((x, index) => {
        const newListItem = addToDom(sectionDiv, 'div', { class: `text-section__list__section-wrapper__item no-select--custom` })
        newListItem.innerHTML = createAccoridonHTML(x, index)
      })
    })

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 1
    }

    const observer = new IntersectionObserver(observerCallback, observerOptions)

    sections.forEach(section => observer.observe(section))
  }
  
  window.onload = () => runMain()
  
  $(function(){
    $(document)
    .on('shopify:section:load', runMain);
  });

})()


